@if (!editMode) {
  <div>
    {{ formattedDate }}
  </div>
} @else {
  <mat-form-field class="form-content">
    <mat-label>Choose a date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="modelDate" (ngModelChange)="onModelChange()" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
}
